//Copy from https://ui5.sap.com/resources/sap/viz/library-dbg.js as enum

export enum ChartColor {
    // Qualitative color
    'sapUiChartPaletteQualitativeHue1' = 'sapUiChartPaletteQualitativeHue1',
    'sapUiChartPaletteQualitativeHue2' = 'sapUiChartPaletteQualitativeHue2',
    'sapUiChartPaletteQualitativeHue3' = 'sapUiChartPaletteQualitativeHue3',
    'sapUiChartPaletteQualitativeHue4' = 'sapUiChartPaletteQualitativeHue4',
    'sapUiChartPaletteQualitativeHue5' = 'sapUiChartPaletteQualitativeHue5',
    'sapUiChartPaletteQualitativeHue6' = 'sapUiChartPaletteQualitativeHue6',
    'sapUiChartPaletteQualitativeHue7' = 'sapUiChartPaletteQualitativeHue7',
    'sapUiChartPaletteQualitativeHue8' = 'sapUiChartPaletteQualitativeHue8',
    'sapUiChartPaletteQualitativeHue9' = 'sapUiChartPaletteQualitativeHue9',
    'sapUiChartPaletteQualitativeHue10' = 'sapUiChartPaletteQualitativeHue10',
    'sapUiChartPaletteQualitativeHue11' = 'sapUiChartPaletteQualitativeHue11',
    'sapUiChartPaletteQualitativeHue12' = 'sapUiChartPaletteQualitativeHue12',
    'sapUiChartPaletteQualitativeHue13' = 'sapUiChartPaletteQualitativeHue13',
    'sapUiChartPaletteQualitativeHue14' = 'sapUiChartPaletteQualitativeHue14',
    'sapUiChartPaletteQualitativeHue15' = 'sapUiChartPaletteQualitativeHue15',
    'sapUiChartPaletteQualitativeHue16' = 'sapUiChartPaletteQualitativeHue16',
    'sapUiChartPaletteQualitativeHue17' = 'sapUiChartPaletteQualitativeHue17',
    'sapUiChartPaletteQualitativeHue18' = 'sapUiChartPaletteQualitativeHue18',
    'sapUiChartPaletteQualitativeHue19' = 'sapUiChartPaletteQualitativeHue19',
    'sapUiChartPaletteQualitativeHue20' = 'sapUiChartPaletteQualitativeHue20',
    'sapUiChartPaletteQualitativeHue21' = 'sapUiChartPaletteQualitativeHue21',
    'sapUiChartPaletteQualitativeHue22' = 'sapUiChartPaletteQualitativeHue22',
    // Semantic color
    'sapUiChartPaletteSemanticBadLight3' = 'sapUiChartPaletteSemanticBadLight3',
    'sapUiChartPaletteSemanticBadLight2' = 'sapUiChartPaletteSemanticBadLight2',
    'sapUiChartPaletteSemanticBadLight1' = 'sapUiChartPaletteSemanticBadLight1',
    'sapUiChartPaletteSemanticBad' = 'sapUiChartPaletteSemanticBad',
    'sapUiChartPaletteSemanticBadDark1' = 'sapUiChartPaletteSemanticBadDark1',
    'sapUiChartPaletteSemanticBadDark2' = 'sapUiChartPaletteSemanticBadDark2',
    'sapUiChartPaletteSemanticCriticalLight3' = 'sapUiChartPaletteSemanticCriticalLight3',
    'sapUiChartPaletteSemanticCriticalLight2' = 'sapUiChartPaletteSemanticCriticalLight2',
    'sapUiChartPaletteSemanticCriticalLight1' = 'sapUiChartPaletteSemanticCriticalLight1',
    'sapUiChartPaletteSemanticCritical' = 'sapUiChartPaletteSemanticCritical',
    'sapUiChartPaletteSemanticCriticalDark1' = 'sapUiChartPaletteSemanticCriticalDark1',
    'sapUiChartPaletteSemanticCriticalDark2' = 'sapUiChartPaletteSemanticCriticalDark2',
    'sapUiChartPaletteSemanticGoodLight3' = 'sapUiChartPaletteSemanticGoodLight3',
    'sapUiChartPaletteSemanticGoodLight2' = 'sapUiChartPaletteSemanticGoodLight2',
    'sapUiChartPaletteSemanticGoodLight1' = 'sapUiChartPaletteSemanticGoodLight1',
    'sapUiChartPaletteSemanticGood' = 'sapUiChartPaletteSemanticGood',
    'sapUiChartPaletteSemanticGoodDark1' = 'sapUiChartPaletteSemanticGoodDark1',
    'sapUiChartPaletteSemanticGoodDark2' = 'sapUiChartPaletteSemanticGoodDark2',
    'sapUiChartPaletteSemanticNeutralLight3' = 'sapUiChartPaletteSemanticNeutralLight3',
    'sapUiChartPaletteSemanticNeutralLight2' = 'sapUiChartPaletteSemanticNeutralLight2',
    'sapUiChartPaletteSemanticNeutralLight1' = 'sapUiChartPaletteSemanticNeutralLight1',
    'sapUiChartPaletteSemanticNeutral' = 'sapUiChartPaletteSemanticNeutral',
    'sapUiChartPaletteSemanticNeutralDark1' = 'sapUiChartPaletteSemanticNeutralDark1',
    'sapUiChartPaletteSemanticNeutralDark2' = 'sapUiChartPaletteSemanticNeutralDark2',
    'sapUiChartPaletteNoSemDiv1Dark2' = 'sapUiChartPaletteNoSemDiv1Dark2',
    'sapUiChartPaletteNoSemDiv1Dark1' = 'sapUiChartPaletteNoSemDiv1Dark1',
    'sapUiChartPaletteNoSemDiv1' = 'sapUiChartPaletteNoSemDiv1',
    'sapUiChartPaletteNoSemDiv1Light1' = 'sapUiChartPaletteNoSemDiv1Light1',
    'sapUiChartPaletteNoSemDiv1Light2' = 'sapUiChartPaletteNoSemDiv1Light2',
    'sapUiChartPaletteNoSemDiv1Light3' = 'sapUiChartPaletteNoSemDiv1Light3',
    // Sequential color
    'sapUiChartPaletteSequentialHue1Light3' = 'sapUiChartPaletteSequentialHue1Light3',
    'sapUiChartPaletteSequentialHue1Light2' = 'sapUiChartPaletteSequentialHue1Light2',
    'sapUiChartPaletteSequentialHue1Light1' = 'sapUiChartPaletteSequentialHue1Light1',
    'sapUiChartPaletteSequentialHue1' = 'sapUiChartPaletteSequentialHue1',
    'sapUiChartPaletteSequentialHue1Dark1' = 'sapUiChartPaletteSequentialHue1Dark1',
    'sapUiChartPaletteSequentialHue1Dark2' = 'sapUiChartPaletteSequentialHue1Dark2',
    'sapUiChartPaletteSequentialHue2Light3' = 'sapUiChartPaletteSequentialHue2Light3',
    'sapUiChartPaletteSequentialHue2Light2' = 'sapUiChartPaletteSequentialHue2Light2',
    'sapUiChartPaletteSequentialHue2Light1' = 'sapUiChartPaletteSequentialHue2Light1',
    'sapUiChartPaletteSequentialHue2' = 'sapUiChartPaletteSequentialHue2',
    'sapUiChartPaletteSequentialHue2Dark1' = 'sapUiChartPaletteSequentialHue2Dark1',
    'sapUiChartPaletteSequentialHue2Dark2' = 'sapUiChartPaletteSequentialHue2Dark2',
    'sapUiChartPaletteSequentialHue3Light3' = 'sapUiChartPaletteSequentialHue3Light3',
    'sapUiChartPaletteSequentialHue3Light2' = 'sapUiChartPaletteSequentialHue3Light2',
    'sapUiChartPaletteSequentialHue3Light1' = 'sapUiChartPaletteSequentialHue3Light1',
    'sapUiChartPaletteSequentialHue3' = 'sapUiChartPaletteSequentialHue3',
    'sapUiChartPaletteSequentialHue3Dark1' = 'sapUiChartPaletteSequentialHue3Dark1',
    'sapUiChartPaletteSequentialHue3Dark2' = 'sapUiChartPaletteSequentialHue3Dark2',
    'sapUiChartPaletteSequentialHue6Light3' = 'sapUiChartPaletteSequentialHue6Light3',
    'sapUiChartPaletteSequentialHue6Light2' = 'sapUiChartPaletteSequentialHue6Light2',
    'sapUiChartPaletteSequentialHue6Light1' = 'sapUiChartPaletteSequentialHue6Light1',
    'sapUiChartPaletteSequentialHue6' = 'sapUiChartPaletteSequentialHue6',
    'sapUiChartPaletteSequentialHue6Dark1' = 'sapUiChartPaletteSequentialHue6Dark1',
    'sapUiChartPaletteSequentialHue6Dark2' = 'sapUiChartPaletteSequentialHue6Dark2',
    'sapUiChartPaletteSequentialNeutralLight3' = 'sapUiChartPaletteSequentialNeutralLight3',
    'sapUiChartPaletteSequentialNeutralLight2' = 'sapUiChartPaletteSequentialNeutralLight2',
    'sapUiChartPaletteSequentialNeutralLight1' = 'sapUiChartPaletteSequentialNeutralLight1',
    'sapUiChartPaletteSequentialNeutral' = 'sapUiChartPaletteSequentialNeutral',
    'sapUiChartPaletteSequentialNeutralDark1' = 'sapUiChartPaletteSequentialNeutralDark1',
    'sapUiChartPaletteSequentialNeutralDark2' = 'sapUiChartPaletteSequentialNeutralDark2',
    'sapUiChoroplethRegionBG' = 'sapUiChoroplethRegionBG',
    'sapUiChartZeroAxisColor' = 'sapUiChartZeroAxisColor',
    'sapUiNegativeElement' = 'sapUiNegativeElement',
    'sapUiCriticalElement' = 'sapUiCriticalElement',
    'sapUiPositiveElement' = 'sapUiPositiveElement',
    'sapUiNeutralElement' = 'sapUiNeutralElement'
}
